import {listen, v$} from './helpers';


const smallBanners = v$('.banner_small'),
    bigBanner = v$('.banner_big')[0],
    overlay = v$('.banner-overlay')[0],
    closeBanners = v$('.banner-close');

const showBanner = (element) => {
    if(element){
        element.classList.add('open');
    }
};
const hideBanner = (element) => {
    element.classList.remove('open');
    if(element.className.includes('_big')){
        overlay.classList.remove('open');
    }
};
if(!localStorage.getItem('isShoved')){
    localStorage.setItem('isShoved','true');
    setTimeout(() => {
        showBanner(bigBanner);
        if(bigBanner) {
            showBanner(overlay);
        }
    },1000*6);
}
let bannerNumber = 0;
const interval = setInterval(() => {
    if (bannerNumber < smallBanners.length) {
        showBanner(smallBanners[bannerNumber]);
        bannerNumber++;
    }
    else {
        clearInterval(interval);
    }
}, 1000 * 2);


listen(closeBanners,'click',e => {
    hideBanner(e.target.parentNode);
});
